import { defineComponent as _defineComponent } from 'vue'
import { mittBus, MITT_TYPES } from '@/business/mitt-bus';
import { SHARE_COUPON_BANNER } from '../config';


export default /*#__PURE__*/_defineComponent({
  __name: 'vitasoy-share-card',
  setup(__props) {

const onClickCard = () => {
  mittBus.emit(MITT_TYPES.bannerShareCouponClick);
};

return { __sfc: true,onClickCard, SHARE_COUPON_BANNER }
}

})